var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 58,
    viewBox: "0 0 80 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_2898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.3727 36.269L72.2277 31.0877L70.6733 19.1707L61.347 15.5438L56.1657 9.3263L50.8984 1.89946L41.2265 0L31.8137 6.21754L27.1505 19.6889L26.4189 22.8583L31.1883 27.9255L34.3256 31.6882L40.5685 34.1167L41.5975 42.0057L44.1897 45.2455L45.5565 50.7087L46.5788 54.461V56.476H80.0001V50.2584L78.4457 44.559L76.3727 36.269ZM55.5616 15.1117L49.085 7.16778L42.0902 5.87246L41.312 4.74916L50.0347 4.4901L56.6838 15.0257L55.5616 15.1117Z",
    fill: "url(#paint0_linear_301_2898)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5072 54.7398L43.5513 51.232L42.2906 46.1886L39.6181 42.8487L38.6736 35.6032L33.0737 33.425L29.6307 29.295L24.5152 23.8588L18.1376 20.62L11.8221 27.3971L11.0154 34.8297L12.1802 39.9954L6.02583 43.4124L5.0761 49.7476L0.149739 56.3175L0 57.5112H44.5072V54.7398Z",
    fill: "url(#paint1_linear_301_2898)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_301_2898",
    x1: 80.6945,
    y1: 0.858295,
    x2: 23.6564,
    y2: 53.4816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_301_2898",
    x1: 45.084,
    y1: 21.1807,
    x2: 8.17641,
    y2: 64.4806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_2898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 57.5112,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStone);
export default __webpack_public_path__ + "static/media/stone.3fe3f91ec33dc525594e25f519fb619e.svg";
export { ForwardRef as ReactComponent };